import React, { useState, useEffect } from 'react';
import { updateInvestidor } from '../services/api';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface Investidor {
    id: number;
    nome: string;
    cpf_cnpj: string;
    contato: string;
}

interface InvestidorEditModalProps {
    investidor: Investidor | null;
    open: boolean;
    onClose: () => void;
    onInvestidorUpdated: () => void;
}

const InvestidorEditModal: React.FC<InvestidorEditModalProps> = ({ investidor, open, onClose, onInvestidorUpdated }) => {
    const [nome, setNome] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [contato, setContato] = useState('');

    useEffect(() => {
        if (investidor) {
            setNome(investidor.nome);
            setCpfCnpj(investidor.cpf_cnpj);
            setContato(investidor.contato);
        }
    }, [investidor]);

    const handleSave = async () => {
        if (!investidor) return;
        const updatedInvestidor = { nome, cpf_cnpj: cpfCnpj, contato };
        try {
            await updateInvestidor(investidor.id, updatedInvestidor);
            onInvestidorUpdated();
            onClose();
        } catch (error) {
            alert('Erro ao atualizar investidor.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Editar Investidor</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
                <TextField label="Nome" value={nome} onChange={e => setNome(e.target.value)} required />
                <TextField label="CPF/CNPJ" value={cpfCnpj} onChange={e => setCpfCnpj(e.target.value)} required />
                <TextField label="Contato" value={contato} onChange={e => setContato(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSave} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default InvestidorEditModal;
